import { createCheckAuthorization, resolveAuthState, splitByScope, validateReverificationConfig } from "./authorization-XX4mKaAz.mjs";

export { createCheckAuthorization, resolveAuthState, splitByScope, validateReverificationConfig };